import {UIRouterReact} from '@uirouter/react';
import {ConfigService} from '../Config/ConfigService';
import {StateService} from '../Routing/StateService';
import {Repos} from '../Repository/Repos';
import {ApiService} from '../Api/ApiService';
import {AppConfig} from '../../App';
import {AppData} from './AppData';

export class Context {
  private readonly configService: ConfigService;
  private readonly apiService: ApiService;
  readonly repos: Repos;
  readonly stateService: StateService;
  readonly appData: AppData;

  router?: UIRouterReact;

  constructor(config: AppConfig) {
    this.configService = new ConfigService(config);
    this.stateService = new StateService();
    this.apiService = new ApiService(this.configService);
    this.repos = new Repos(this.apiService);

    this.appData = new AppData(this);
  }

  async init() {}

  setRouter = (router: UIRouterReact) => {
    this.router = router;

    this.onSetRouter();
  };

  private onSetRouter() {
    this.stateService.router = this.router;
  }
}
